<template>
    <v-dialog
        :value="showDialog"
        persistent
        max-width="550"
    >        
      <v-card>
        <v-card-title class="text-h5 white--text meablue">Questions about the application?</v-card-title>
        <v-card-text>
            <p style="font-size:1.3em; font-weight:400;" class="pt-3">Please contact us by email or phone:</p>
            <p><font-awesome-icon :icon="['far', 'fa-envelope']" class="mr-2"></font-awesome-icon>{{email.who}}: <a :href="`mailto:${email.val}`">{{email.val}}</a>
            <br/><font-awesome-icon :icon="['far', 'fa-phone-alt']" class="mr-2"></font-awesome-icon>{{number.who}}: {{number.val}}</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>            
          <v-btn
            color="blue darken-1"
            text
            @click="$emit('close-dialog')"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
  import axios from 'axios';
  export default {
    name: 'HelpDialog',
    data:()=>({
        number:{who:null, val:null},
        email:{who:null, val:null}
    }),
    props: {
        showDialog: Boolean
    },
    methods:{
        async get_help_center_info(){
            const payload = {doCmd: 'get_help_info'};
            const help_res = await axios.post(`${this.$baseURL}/common/application/`, JSON.stringify(payload), {
                headers: {'Content-Type':'application/json'}
            });

            const { data:{result} } = help_res;
            this.number = result.number;
            this.email = result.email;
        }   
    },
    beforeMount(){
        this.get_help_center_info();
    }
  }
</script>
<style scoped>
.meablue{
    background-color:var(--meablue);
}
</style>